// Imported in SearchForm and in EditSearch in account
import React from 'react'
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import SelectLocation from './SelectLocation'
import SelectPeriod from './SelectPeriod'
import SelectHours from './SelectHours'
import moment from 'moment'


export default class SearchBox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ...props, modal: false
        }
    }

    submitSearch = () => {
        if (this.validateForm() && this.props.submitSearch) {
            const {pickLocation, dropLocation, dropVisible} = this.locations.state
            const {from, to} = this.period.state
            const {start_hour, end_hour} = this.hours.state
            const r = {
                start_location: pickLocation && pickLocation.value,
                end_location: dropVisible && dropLocation && dropLocation.value,
                start_date: moment(from).format("Y-MM-DD"),
                end_date: moment(to).format("Y-MM-DD"),
                start_hour: start_hour,
                end_hour: end_hour
            }
            this.props.submitSearch(r)
        }
    }

    submitExtSearch = () => {
        if (this.props.submitSearch) {
            const {start_hour, end_hour} = this.hours.state
            const r = {
                start_location: this.props.start_location,
                end_location: this.props.end_location,
                start_date: this.props.start_date,
                end_date: this.props.end_date,
                start_hour: start_hour,
                end_hour: end_hour
            }
            this.props.submitSearch(r)
        }
    }

    validateForm = () => {
        const {pickLocation, dropLocation, dropVisible} = this.locations.state
        if (!(pickLocation && parseInt(pickLocation.value) > 0)) {
            console.log('here')
            this.locations.setState({pickError: true})
            return this.showModal(this.props.t.e_pick)
        }
        if (!(!dropVisible || (dropLocation && parseInt(dropLocation.value) > 0))) {
            this.locations.setState({dropError: true})
            return this.showModal(this.props.t.e_return)
        }
        if (!this.period.validatePeriod()) {
            return this.showModal(this.props.t.e_min)
        }
        return true
    }

    showModal = (formError) => {
        this.setState({formError})
        this.toggle()
        return false
    }

    renderErrors = () => {
        if (this.state.formError)
            return (
                <Modal isOpen={this.state.modal} toggle={() => this.toggle()}>
                    <ModalHeader toggle={this.toggle} className={''}>{this.props.t.e_header}:</ModalHeader>
                    <ModalBody>
                        {this.state.formError}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => this.toggle()}>{this.props.t.e_close}</Button>
                    </ModalFooter>
                </Modal>
            )
        else return null
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    render() {
        const {ext} = this.props
        return (
            <div className={'mb-3'}>
                {this.renderErrors()}
                {!ext && <SelectLocation {...this.props} ref={locations => this.locations = locations}/>}
                {!ext && <SelectPeriod ref={period => this.period = period}  {...this.props}/>}
                <SelectHours start_hour={this.props.start_hour} end_hour={this.props.end_hour}
                             t={this.props.t} ref={hours => this.hours = hours}/>
                <br/>
                <div className={'row'}>
                    <div className={'col'}>
                        <div className={' pull-right mr-sm-4'}>
                            {this.props.edit &&
                            <a href="#" onClick={(e) => {e.preventDefault();history.back()}}>{this.props.t.cancel}</a>
                            }
                            <Button className={'ml-4 btn btn-success btn-lg'} onClick={ext ? this.submitExtSearch : this.submitSearch}>
                                {!this.props.edit && this.props.t.search || this.props.t.edit_period}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


